import AuthActions from './actions'

const INITIAL_STATE = {
  authUser: {},
  isAuthenticated: null,
  isProcessing: false,
  isRegistered: false,
  isError: false,
  errorMessage: '',
  userRole: {
    isError: false,
    isProcessing: false,
    role: '',
    permissions: []
  }
}

function AuthReducer (state = INITIAL_STATE, action) {
  switch (action.type) {
    case AuthActions.SIGNIN:
      return { ...state, isProcessing: true, isAuthenticated: false, isError: false }
    case AuthActions.SIGNIN_SUCCESSFUL:
      return { ...state, isProcessing: false, isAuthenticated: true, isError: false, authUser: action.payload, errorMessage: {} }
    case AuthActions.SIGNIN_REJECTED:
      return { ...state, isProcessing: false, isAuthenticated: false, authUser: {}, isError: true, errorMessage: action.payload }
    case AuthActions.GET_ROLE:
      return { ...state, userRole: { ...state.userRole, isProcessing: true, isError: false } }
    case AuthActions.GET_ROLE_SUCCESSFUL:
      return { ...state, userRole: { ...state.userRole, isProcessing: false, isError: false, role: action.payload.name, permissions: action.payload.permissions, errorMessage: {} } }
    case AuthActions.GET_ROLE_REJECTED:
      return { ...state, userRole: { ...state.userRole, isProcessing: false, isError: true, errorMessage: action.payload } }
    case AuthActions.LOGOUT:
      return { ...state, isProcessing: true }
    case AuthActions.LOGOUT_SUCCESSFUL:
      return { ...state, isProcessing: false, isAuthenticated: false, authUser: {}, errorMessage: '' }
    case AuthActions.ISLOGGEDIN:
      return { ...state, isProcessing: false, isAuthenticated: true, authUser: action.payload }
    case AuthActions.ISLOGGEDOUT:
      return { ...state, isProcessing: false, isAuthenticated: false, authUser: {} }
    default:
      return state
  }
}

export default AuthReducer



// WEBPACK FOOTER //
// ./src/modules/auth/reducers.js